"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
function parseDate(object) {
    for (const [key, value] of Object.entries(object)) {
        if (_1.isObject(value)) {
            object[key] = parseDate(value);
        }
        else if (typeof value === 'string') {
            if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value)) {
                object[key] = new Date(value);
            }
        }
    }
    return object;
}
class json {
    static stringify(value, space) {
        return JSON.stringify(value, null, space);
    }
    static parse(value) {
        const data = JSON.parse(value);
        return _1.isObject(data) ? parseDate(data) : data;
    }
}
exports.default = json;
